module.exports = __webpack_public_path__ + "static/media/lightgreensquarelogo.75805491.png";